// src/Customer/CustomerDashboard/SupportAndHelpCenter.js

import React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  Divider,
} from "@mui/material";

import CustomerLayout from "../CustomerLayout";

const SupportAndHelpCenter = () => {
  return (
    <CustomerLayout>
      <Box
        sx={{
          maxWidth: 980,
          mx: "auto",
          py: { xs: 2, md: 4 },
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            letterSpacing: "-0.02em",
            mb: 1,
          }}
        >
          Support Center
        </Typography>

        <Typography
          sx={{
            color: "text.secondary",
            fontSize: "1rem",
            lineHeight: 1.6,
            mb: 4,
            maxWidth: 820,
          }}
        >
          Find answers, review platform guidance, 
          or submit a support request related to loads, 
          transportation activity, payments, or your account.
        </Typography>

        <Paper
          elevation={0}
          sx={{
            border: "1px solid #e5e7eb",
            borderRadius: 3,
            p: { xs: 3, md: 4 },
            boxShadow:
              "0 8px 24px rgba(15, 23, 42, 0.06)",
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: 700,
              mb: 3,
            }}
          >
            Frequently Asked Questions
          </Typography>

          <Box sx={{ mb: 2.5 }}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 0.5,
              }}
            >
              How do I track a load?
            </Typography>

            <Typography
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
              }}
            >
              Go to Loads, select Track Load,
              and review the current status,
              estimated arrival, and latest
              location updates.
            </Typography>
          </Box>

          <Divider sx={{ my: 2.5 }} />

          <Box sx={{ mb: 2.5 }}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 0.5,
              }}
            >
              How do I post a load?
            </Typography>

            <Typography
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
              }}
            >
              Go to Dashboard and complete
              the Post a Load form with pickup
              details, drop-off details,
              shipment information,
              and service preferences.
            </Typography>
          </Box>

          <Divider sx={{ my: 2.5 }} />

          <Box sx={{ mb: 3 }}>
            <Typography
              sx={{
                fontWeight: 700,
                mb: 0.5,
              }}
            >
              Can drivers or carriers negotiate pricing?
            </Typography>

            <Typography
              color="text.secondary"
              sx={{
                lineHeight: 1.6,
              }}
            >
              Yes. HaggleFreight is designed
              to support direct communication
              and pricing flexibility between
              customers and drivers or carriers.
            </Typography>
          </Box>

          <Box sx={{ mt: 3 }}>
            <Button
              variant="contained"
              href="/customer/ticket-system"
              sx={{
                py: 1.3,
                px: 4,
                textTransform: "none",
                fontWeight: 700,
              }}
            >
              Submit Ticket
            </Button>
          </Box>
        </Paper>
      </Box>
    </CustomerLayout>
  );
};

export default SupportAndHelpCenter;